<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex xs10 offset-xs1>
        <v-container grid-list-xl fluid>
          <v-layout row wrap>
            <v-flex xs12>
              <h1 class="display-1">Promocode Management
                  <v-btn @click="showList = true" v-if="showList === false" color="success" class="right">List Promocodes</v-btn>
                  <v-btn @click="showList = false" v-if="showList === true" color="success" class="right">Add Promocode</v-btn>
              </h1>
            </v-flex>
            <v-flex xs8 offset-xs2 v-if="showList === false">
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="headline">Add Promocode</h2>
                      <div v-if="$v.type.$error" class="red--text">Please select Type</div>
                      <!-- <v-select
                        v-model="type"
                        :items="availableTypes"
                        label="Type"
                        menu-props="bottom"
                      ></v-select> -->

                      <v-radio-group v-model="type" row>
                        <v-label><strong>Type:</strong></v-label>
                        <v-radio label="Fixed Amount" color="primary" value="Fixed Amount"></v-radio>
                        <v-radio v-if="['manager'].includes(loggedInUser.position.role)" label="Percentage" color="primary" value="Percentage on Items Only"></v-radio>
                        <v-radio v-if="['manager'].includes(loggedInUser.position.role)" label="Percentage on Fabrics" color="primary" value="Percentage on Fabrics"></v-radio>
                        <v-radio v-if="['manager'].includes(loggedInUser.position.role)" label="Percentage on Motor Options" color="primary" value="Percentage on Motor Options"></v-radio>
                      </v-radio-group>

                      <v-flex xs6 mx-auto>
                        <div v-if="$v.name.$error" class="red--text">Please enter Promocode Name</div>
                        <v-text-field label="Name" v-model="name"></v-text-field>

                        <div v-if="$v.amount.$error" class="red--text">Please enter Amount</div>
                        <v-text-field :label="type.includes('Percentage on') ? '% Amount':'Amount'" v-model="amount"></v-text-field>
                        <v-select
                          v-if="['Percentage on Items Only', 'Percentage on Fabrics', 'Percentage on Motor Options'].includes(type)"
                          v-model="appliesTo"
                          :items="availableProducts"
                          label="Products"
                          multiple
                          menu-props="bottom"
                        ></v-select>
                        <v-select
                          v-if="type === 'Percentage on Fabrics'"
                          v-model="appliesToFabrics"
                          :items="availableFabrics"
                          label="Fabrics"
                          multiple
                          menu-props="bottom"
                          searchable
                        ></v-select>
                        <v-select
                          v-if="type === 'Percentage on Motor Options'"
                          v-model="appliesToMotorOptions"
                          :items="availableMotorOptions"
                          label="Motor Options"
                          multiple
                          menu-props="bottom"
                          searchable
                        ></v-select>
                        <v-checkbox v-if="type === 'Percentage on Items Only'" label="Freeship?" v-model="freeship"></v-checkbox>
                        <!-- <v-checkbox label="Enabled?" v-model="enabled"></v-checkbox>
                        <v-checkbox label="Is Obey Off?" v-model="isObeOff"></v-checkbox> -->
                      </v-flex>
                      <v-btn large color="primary" @click="addPromocode">Add Promocode</v-btn>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

            <v-flex xs12 v-if="showList === true">
              <v-card>
                <v-container grid-list-xl fluid>
                  <v-layout row wrap>
                    <v-flex xs8 offset-xs2>
                        <v-text-field label="Search" v-model="search"></v-text-field>
                    </v-flex>
                    <v-flex xs12>
                      <v-data-table :headers="headers" :items="promocodes">
                        <template slot="items" slot-scope="props">
                          <td>{{ props.item.name }}</td>
                          <td v-if="props.item.appliesTo" v-html="props.item.appliesTo.join(',<br>')" width="30%"></td>
                          <td v-if="props.item.appliesToFabrics" v-html="props.item.appliesToFabrics.join(',<br>')" width="30%"></td>
                          <td>{{ props.item.isObeOff }}</td>
                          <td>{{ props.item.enabled }}</td>
                          <td>{{ props.item.type }}</td>
                          <td>{{ props.item.amount }}</td>
                          <td>
                            <button @click="deletePromocode(props.item._id)">Delete</button>
                          </td>
                        </template>
                    </v-data-table>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card>
            </v-flex>

            <v-snackbar dark top v-model="snackbar" :timeout="3000">
              {{ popupText }}
              <v-btn dark flat @click="snackbar = false">Close</v-btn>
            </v-snackbar>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import PromocodeService from '@/services/PromocodeService.js'
import FabricService from '@/services/FabricService.js'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      snackbar: false,
      popupText: '',
      headers: [
        { text: 'Promocode', value: 'name' },
        { text: 'Applies To', value: 'appliesTo' },
        { text: 'Applies To Fabrics', value: 'appliesToFabrics' },
        { text: 'Is Obe Off', value: 'isObeOff' },
        { text: 'Enabled', value: 'enabled' },
        { text: 'Type', value: 'type' },
        { text: 'Amount', value: 'amount' },
        { text: 'Actions', value: 'actions' }
      ],
      search: '',
      promocodes: [],
      promocodesAll: [],
      name: null,
      appliesTo: [],
      appliesToFabrics: [],
      freeship: false,
      isObeOff: false,
      enabled: true,
      type: 'Fixed Amount',
      amount: null,
      showList: true,
      availableFabrics: [],
      appliesToMotorOptions: [],
      availableMotorOptions: [
        'Somfy Altus 28 1.5nm',
        'Somfy Sonesse 30 2.0nm',
        'Somfy Altus 40mm RTS',
        'Somfy Sonesse RTS 40mm',
        'Somfy LS 40',
        'Somfy Sonesse WT 40'
      ],
      availableProducts: ['Roller Blind',
        'Linked Roller Blind',
        'Double Roller Blind',
        'Linked Double Roller Blind',
        'Roman Blind',
        'Soft Roman Blind',
        'Venetian Blind',
        'Honeycomb Blind',
        'Shutter',
        '3D Shutters',
        'Panel Glide Blind',
        'Vertical Blind',
        'Curtain',
        'Double Curtain',
        'Lined Curtain',
        'Curved Curtain',
        // 'Corner Curtain', // not in use
        'Bay Window Curtain',
        'Motor Accessories',
        'Pelmets',
        'Misc'],
      availableTypes: [
        'Fixed Amount'
      ],
      loggedInUser: JSON.parse(atob(localStorage.getItem('user')))
    }
  },
  mounted () {
    this.getPromocodes()
    console.log(this.loggedInUser)
    if (this.loggedInUser.position && ['manager'].includes(this.loggedInUser.position.role)) {
      this.availableTypes = [
        // 'Percentage',
        'Percentage on Items Only',
        // 'Free Shipping / Insurance',
        'Fixed Amount',
        'Percentage on Fabrics',
        'Percentage on Motor Options'

      ]
      this.getFabrics()
    }
  },
  watch: {
    search: {
      handler (val) {
        if (!this.search || this.search === '') {
          this.promocodes = this.promocodesAll
        } else {
          this.promocodes = this.promocodesAll.filter(function (item) {
            return item.amount === parseInt(val) || item.name.toLowerCase().includes(val.toLowerCase()) || (item.appliesTo && item.appliesTo.join(',').toLowerCase().includes(val.toLowerCase())) || (item.appliesToFabrics && item.appliesToFabrics.join(',').toLowerCase().includes(val.toLowerCase()))
          })
        }
        // console.log(this.promocodes)
      },
      deep: true
    }
  },
  validations: {
    name: { required },
    amount: { required },
    type: { required }
  },
  methods: {
    async getFabrics () {
      this.availableFabrics = []
      const response = await FabricService.getFabrics()

      var fabrics = response.data.fabrics
      for (let index = 0; index < fabrics.length; index++) {
        const fabric = fabrics[index]
        if (!this.availableFabrics.includes(fabric.name)) {
          this.availableFabrics.push(fabric.name)
        }
      }
      this.availableFabrics.sort()
    },
    async getPromocodes () {
      const response = await PromocodeService.getPromocodes()
      this.promocodes = response.data.promocodes
      this.promocodesAll = response.data.promocodes
    },

    async addPromocode () {
      if (!this.validateFields()) { return }
      if (this.type === 'Fixed Amount') {
        let response = await PromocodeService.checkOrderCode(this.name)
        if (response.data.order === 0) {
          this.popupText = 'promocode is not valid'
          this.snackbar = true
          return
        }
      }
      let responseAdd = await PromocodeService.addPromocode({
        name: this.name,
        appliesTo: this.appliesTo,
        appliesToFabrics: this.appliesToFabrics,
        appliesToMotorOptions: this.appliesToMotorOptions,
        isObeOff: this.isObeOff,
        freeship: this.freeship,
        enabled: this.enabled,
        type: this.type,
        amount: this.amount
      })

      if (responseAdd.data.success === true || responseAdd.data.success === 'true') {
        this.popupText = 'promocode is added successfully'
        this.snackbar = true
      }

      this.name = null
      this.appliesTo = null
      this.appliesToFabrics = null
      this.appliesToMotorOptions = null
      this.isObeOff = false
      this.enabled = true
      this.type = 'Fixed Amount'
      this.freeship = null
      this.amount = null
      this.getPromocodes()
    },

    async deletePromocode (id) {
      await PromocodeService.deletePromocode(id)

      this.getPromocodes()
    },
    filterRecords () {
      if (!this.search || this.search === '') {
        this.promocodes = this.promocodesAll
      } else {
        this.promocodes = this.promocodesAll.filter(function (item) {
          var name = item.name
          return name.indexOf('pratik')
        })
      }
    },
    validateFields () {
      this.$v.type.$touch()
      this.$v.name.$touch()
      this.$v.amount.$touch()

      if (this.$v.type.$pending || this.$v.type.$error) return false
      if (this.$v.name.$pending || this.$v.name.$error) return false
      if (this.$v.amount.$pending || this.$v.amount.$error) return false
      return true
    },
    getAppliesTo (item) {
      if (item.appliesTo.length) {
        return item.appliesTo.join(',<br>')
      }
      if (item.appliesToFabrics.length) {
        return item.appliesToFabrics.join(',<br>')
      }
      return ''
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/Promocodes.vue